import { BroadcastChannel } from 'broadcast-channel';

import { history } from '@/modules/Root/RootModule';
import { BrowserStorageService } from '@/services/BrowserStorage';
import { parseJwtPayload } from '@/utils/parse-jwt-payload';

import { BroadcastActions, BroadcastMessageType } from './types';

type BroadcastServiceInterface = BroadcastChannel<ReturnType<BroadcastActions>>;
const BroadcastService: BroadcastServiceInterface = new BroadcastChannel('gaf-pp-broadcast');

BroadcastService.addEventListener('message', message => {
  switch (message.type) {
    case BroadcastMessageType.CheckIfTheSessionIsTheSame: {
      const jwtPayload = parseJwtPayload(message.payload);
      const isAdminToken = jwtPayload.assistedByAdmin === 'True';
      const portalAccessToken = BrowserStorageService.portalAccessToken.get(isAdminToken);

      if (portalAccessToken && message.payload !== portalAccessToken) {
        history.push('/logout');
      }

      return;
    }

    case BroadcastMessageType.DropAdminSession: {
      BrowserStorageService.portalAccessToken.remove(true);
      history.push('/logout');

      return;
    }

    case BroadcastMessageType.DropAllSessions: {
      history.push('/logout');

      break;
    }

    default:
      break;
  }
});

export { BroadcastService };
